import { useQuery } from '@tanstack/react-query';
import { registerActions } from '@/lib/actions';
import { registerCommands, registerGlobal } from '@/lib/slots';
import '../../../styles/compose.css';
import { ComposerHost } from './ComposerHost';
import { composeInfoQuery } from './data';
import { ListProgress } from './ListProgress';
import { openListSend } from './ListSend';
import { openComposer } from './state';

// The composer and the list send dialog: registers their globals and the compose and listSend actions.
export function setupCompose(): void {
  registerGlobal('composer', ComposerHost);
  registerGlobal('listSendProgress', ListProgress);
  registerActions({
    compose: (req) => openComposer(req ?? {}),
    listSend: (req) => openListSend(req),
  });
  registerCommands(() => {
    const { data } = useQuery({ ...composeInfoQuery, staleTime: 5 * 60_000 });
    const from = data?.mailboxes.find((m) => m.id === data.defaultMailboxId)?.address;
    return [
      {
        id: 'compose',
        title: 'Write an email',
        sub: from ? `From ${from}` : undefined,
        icon: 'edit',
        keys: 'E',
        keywords: 'compose new email message mail send',
        run: () => openComposer({}),
        order: 100,
      },
    ];
  });
}
